import { Row, Col, message } from "antd";
import { useEffect, useState } from "react";
import { NavLink, Route } from "react-router-dom";
import { GetAllProblemList, Searchkeyword, UserRecode } from "./ajax";
import { RenderHtml3 } from "../components/renderhtml";
import { ToublePagePh } from "./troublepage";
import { BottomIfor } from "./bottom/bottominfo";
import { ButtonforPh } from "./bottom/buttomforph";
import { Floatingpc } from "../components/floatingpc";
import { Floatingph } from "../components/floatingph";

function CommonProblem(props) {
  const [data, setData] = useState([]);
  const reload = async () => {
    let res = await GetAllProblemList();
    if (res.code !== 0) {
      message.error(res.message);
      return;
    } else {
      let parentArr = res.data
        .filter((i) => i.parentId === 0)
        .sort((a, b) => b.sort - a.sort);
      let numArr = [];
      parentArr.forEach((i) => {
        let arr = res.data
          .filter((j) => j.parentId === i.id)
          .sort((a, b) => b.sort - a.sort);
        numArr = [...numArr, i];
        arr.forEach((j) => {
          let narr = res.data
            .filter((k) => k.parentId === j.id)
            .sort((a, b) => b.sort - a.sort);
          if (narr.length) {
            numArr = [...numArr, j, ...narr];
          } else {
            numArr = [...numArr, j];
          }
        });
      });
      setData(numArr);
    }
  };
  useEffect(() => {
    reload();
  }, []);

  return (
    <div>
      <Route
        path={[`/commonproblem/seid/:id`, `/commonproblem/search/:keyword`]}
        render={(p) => (
          <TroublePge data={data} setData={setData} {...p} reload={reload} />
        )}
      />
      {/* <Route path={[`/commonproblem/detail`]} component={ToublePagePh}/> */}
      {/* {data.length?<TroublePge {...props} data={data} clickId={clickId}  setClickId={setClickId}/>:''} */}
    </div>
  );
}
export function TroublePge(props) {
  let { data, setData, reload } = props;
  const [keyword, setKeyWord] = useState({ keyword: "" });
  const [shows, setShow] = useState(false);
  const [showmp, setShowmp] = useState(false);
  const [text, setText] = useState("一键复制QQ号");
  const showWindow = (a) => {
    setShow(a);
    setText("一键复制QQ号");
  };
  const showFloating = (e) => {
    setShowmp(true);
    e.nativeEvent.stopImmediatePropagation();
  };
  const hideFloating = (e) => {
    setShowmp(false);
    setText("一键复制QQ号");
  };
  useEffect(() => {
    document.addEventListener("touchstart", hideFloating);
  }, []);
  useEffect(() => {
    if (window.innerWidth > 750 && props.match.params.id * 1 === 0) {
      //为了跳转常见问题时默认选中第一个
      props.history.replace(
        `/commonproblem/seid/${
          data.length &&
          data
            .filter((i) => i.parentId === 0)
            .filter((i) => i.showStatus === 1)[0].id
        }`
      );
    }
    // if(window.screen.width>750&&props.match.params.id*1===0){
    //    props.history.replace(`/commonproblem/seid/${data.length&&data.filter(i=>i.parentId===0).filter(i=>i.showStatus===1)[0].id}`)
    // }
  }, [props.match.params.id, data, props.history]);

  let json = props.location.pathname.split("/")[4];

  useEffect(() => {
    if (props.location.pathname.match("search")) {
      setKeyWord((state) => ({
        ...state,
        keyword:
          props.location.pathname.split("/")[
            props.location.pathname.split("/").length - 1
          ],
      }));
    } else {
      setKeyWord((state) => ({ ...state, keyword: "" }));
    }
  }, [props.location.pathname]);

  async function onchange(value) {
    if (!keyword.keyword) return;
    props.history.push(`/commonproblem/search/${keyword.keyword}`);
  }

  async function checked(value) {
    if (!value) return;
    let res = await Searchkeyword({ keyword: value.toLowerCase() });
    if (res.code !== 0) {
      message.error(res.message);
      return;
    } else {
      props.history.push(`/commonproblem/search/${value}`);
    }
  }

  let json2 = props.location.pathname.split("/")[2];

  return (
    <Row>
      <Col xs={0} sm={0} md={0} lg={24} xl={24}>
        <Floatingpc
          show={shows}
          showWindow={showWindow}
          text={text}
          setText={setText}
        />
        <div className="troublepart">
          <div className="troubletitle">
            <div className="title">
              <div>
                QUESTION <span>&</span> ANSWER
              </div>
              <div>问题与回答</div>
            </div>
          </div>
          <div className="troublepartcontent">
            <div className="troubleleftnav">
              <div className="searchpart">
                <div className="searchbox">
                  <input
                    className="searchtext"
                    id="inputvalue"
                    type="text"
                    placeholder="搜索问题"
                    value={keyword.keyword}
                    onKeyPress={(e) => {
                      if (e.charCode === 13) {
                        checked(e.target.value);
                      }
                    }}
                    onChange={(e) => {
                      setKeyWord((state) => ({
                        ...state,
                        keyword: e.target.value,
                      }));
                    }}
                  />
                  <div className="searchicon" onClick={onchange}></div>
                </div>
                <div className="titlenav">
                  {data
                    .filter((i) => i.parentId === 0 && i.showStatus === 1)
                    .map((j) => {
                      return (
                        <NavLink
                          activeClassName="activenav"
                          className={`onelayertitlestyle `}
                          to={`/commonproblem/seid/${j.id}`}
                          key={j.id}
                        >
                          <div>{j.title}</div>
                        </NavLink>
                      );
                    })}
                </div>
              </div>
            </div>
            {/* 匹配路由的代码要一直存在*/}
            <Route
              path={`/commonproblem/seid/:id/:newId`}
              render={(p) => <Filedetail data={data} {...p} />}
            />
            <Route
              path={`/commonproblem/search/:keyword`}
              render={(p) => <Searchresult data={data} {...p} />}
            />
            {json2 !== "search" && !json && (
              <Troublecontent data={data} setData={setData} {...props} />
            )}
          </div>
        </div>
        <BottomIfor />
      </Col>
      <Col xs={24} sm={24} md={24} lg={0} xl={0}>
        <Floatingph
          showmp={showmp}
          showFloating={showFloating}
          text={text}
          setText={setText}
        />
        <ToublePagePh data={data} {...props} reload={reload} />
        {/* <img width="100px" height="100px" src={`${require('../../public/coursepective.png')}`}/> */}
        <ButtonforPh />
      </Col>
    </Row>
  );
}

function Troublecontent(props) {
  //一级路由下右边展示的内容，展示内容为二级标题和三级标题
  let { data } = props;
  let id = props.match.params.id * 1;
  const [active, setActive] = useState([]);
  return (
    <div className="troubleright">
      {
        <div>
          <div className="troublepartnav">
            <div className="onelayernav">
              {data.filter((i) => i.id === id)[0] &&
                data.filter((i) => i.id === id)[0].title}
            </div>
          </div>
          <div className="troublepartcontentbox">
            {data
              .filter((i) => i.parentId === id && i.showStatus === 1)
              .map((i) => {
                return (
                  <div className="setitlenav" key={i.id}>
                    <div className="setitlestyle">{i.title}</div>
                    <div className="thlist">
                      {data
                        .filter(
                          (j) => j.parentId === i.id && j.showStatus === 1
                        )
                        .map((i) => {
                          return (
                            <div key={i.id}>
                              <div
                                className="everytitle"
                                onClick={() => {
                                  setActive((arr) => {
                                    let index = arr.indexOf(i.id);
                                    if (index === -1) {
                                      arr.push(i.id);
                                    } else {
                                      arr.splice(index, 1);
                                    }
                                    return [...arr];
                                  });
                                }}
                              >
                                {i.title}
                              </div>
                              {/* style={active.indexOf(i.id)!==-1?{maxHeight:1500,transition:'maxHeight 1.3s'}:{maxHeight:0,visibility:'hidden'}} */}
                              <div
                                className={`${
                                  active.indexOf(i.id) !== -1
                                    ? "toexpand"
                                    : "toupexpand"
                                }`}
                                style={{ marginLeft: 30 }}
                              >
                                <RenderHtml3
                                  flow={760}
                                  state={{ content: i.content }}
                                />
                              </div>
                            </div>
                          );
                        })}
                    </div>
                    {/* <div style={{marginLeft:25}}>{active.map(i=>(i))}</div> */}
                  </div>
                );
              })}
          </div>
        </div>
      }
    </div>
  );
}

function Filedetail(props) {
  const [datalist, setDataList] = useState({ list1: [], list2: [] });
  let { data } = props;

  useEffect(() => {
    const recode = async () => {
      let res = await UserRecode({ id: props.match.params.newId });
      if (res.code !== 0) {
        message.error(res.message);
        return;
      } else {
      }
    };
    recode();
  }, [props.match.params.newId]);

  useEffect(() => {
    let filterdata = data.filter((i) => i.id === props.match.params.id * 1);
    if (filterdata.length) {
      let json =
        filterdata[0].parentId === 0
          ? data.filter((i) => i.id === props.match.params.id * 1)
          : data.filter((i) => i.id === filterdata[0].parentId);
      props.history.replace(
        `/commonproblem/seid/${json[0].id}/${props.match.params.newId}`
      );
      setDataList((state) => ({ ...state, list2: json }));
    }
  }, [props.match.params.id, data, props.history, props.match.params.newId]);
  useEffect(() => {
    setDataList((state) => ({
      ...state,
      list1: data
        .filter((i) => i.id === props.match.params.newId * 1)
        .filter((i) => i.showStatus === 1),
    }));
  }, [props.match.params.newId, data]);
  return (
    <div className="troubleright">
      <div className="troublepartnav">
        <div className="onelayernav">
          <div>
            <NavLink
              style={{ cursor: "pointer", color: "#767676" }}
              to={`/commonproblem/seid/${props.match.params.id}`}
            >
              {datalist.list2.length && datalist.list2[0].title}
            </NavLink>
            <span style={{ margin: "0 0.03rem" }}>/</span>
            <span className="thirdtitle">
              {datalist.list1.length && datalist.list1[0].title}
            </span>
          </div>
        </div>
      </div>
      <div className="troublepartcontentbox">
        <div className="topthirdtitle">
          {datalist.list1.length && datalist.list1[0].title}
        </div>
        <div className="downcontent">
          <RenderHtml3
            flow={1000}
            state={{
              content: datalist.list1.length && datalist.list1[0].content,
            }}
          />
        </div>
      </div>
    </div>
  );
}

function Searchresult(props) {
  const [result, setResult] = useState([]);
  useEffect(() => {
    const searchFn = async () => {
      setResult([]);

      let res = await Searchkeyword({ keyword: props.match.params.keyword });
      if (res.code !== 0) {
        message.error(res.message);
        return;
      } else {
        props.history.replace(
          `/commonproblem/search/${props.match.params.keyword}`
        );
        setResult(
          res.data.map((i) => {
            let Rex = new RegExp(props.match.params.keyword, "ig");
            let newContent = i.content.replace(Rex, (value) => {
              return `<span class='keypress'>${value}</span>`;
            });
            let newTitle = i.title.replace(Rex, (value) => {
              return `<span class='keypress'>${value}</span>`;
            });

            return { ...i, content: newContent, title: newTitle };
          })
        );
      }
    };
    searchFn();
  }, [props.match.params.keyword, props.history]);

  return (
    <div className="troubleright">
      <div className="troublepartnav">
        <div className="onelayernavsearh">
          关于“<span className="keyword">{props.match.params.keyword}</span>”,{" "}
          <span style={{ marginLeft: 0.05 + "rem" }}>
            找到了<span className="lengthstyle">{result.length}</span>个相关结果
          </span>
        </div>
      </div>
      <div className="troublepartcontentbox">
        {result.map((i) => {
          return (
            <div className="setitlenav" key={i.id}>
              <NavLink
                className="setitlestyle"
                target="_blank"
                to={`/commonproblem/seid/${i.parentId}/${i.id}`}
                dangerouslySetInnerHTML={{ __html: i.title }}
              ></NavLink>
              <NavLink
                className="thlistresult"
                target="_blank"
                to={`/commonproblem/seid/${i.parentId}/${i.id}`}
                dangerouslySetInnerHTML={{ __html: i.content }}
              ></NavLink>
            </div>
          );
        })}
      </div>
    </div>
  );
}

// function TroublePgeph(props){
//     let {data}=props

//     return(
//         <div>
//              {
//                             data.filter(i=>i.parentId===0).filter(i=>i.showStatus===1).map(j=>{
//                                 return(
//                                     <NavLink  className="onelayertitlestyle"  to={`/commonproblem/seid/${j.id}/1`} key={j.id} ><div>{j.title}</div></NavLink>
//                                 )
//                             })
//                     }
//         </div>
//     )
// }

// function SecondRouter(props){
//     return(
//         <div>123</div>
//     )
// }
export default CommonProblem;
